import { render, staticRenderFns } from "./customer.vue?vue&type=template&id=55dc08be&scoped=true&"
import script from "./customer.js?vue&type=script&lang=js&"
export * from "./customer.js?vue&type=script&lang=js&"
import style0 from "./customer.vue?vue&type=style&index=0&id=55dc08be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55dc08be",
  null
  
)

export default component.exports